/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const TarifDialog = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
      <Dialog open={tarifDialogOpen} onOpenChange={setTarifDialogOpen}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader className="border-b pb-3 mb-2">
            <DialogTitle className="flex items-center gap-2 text-xl">
              <DollarSign className="h-5 w-5 text-emerald-600" />
              {editingTarif ? 'Modifier le tarif' : 'Nouveau tarif'}
            </DialogTitle>
            <DialogDescription>
              Configurez les paramètres de tarification pour ce type de lead
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-5 py-2">
            {/* === Section 1 : Identification === */}
            <section className="space-y-3">
              <h3 className="text-xs font-bold uppercase tracking-wider text-emerald-700 flex items-center gap-2 border-l-4 border-emerald-500 pl-2">
                Identification
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold text-slate-700">Nom du tarif *</Label>
                  <Input
                    value={tarifForm.nom}
                    onChange={(e) => setTarifForm({...tarifForm, nom: e.target.value})}
                    placeholder="Ex: Lead BTP Premium"
                    data-testid="tarif-form-nom"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold text-slate-700">Code *</Label>
                  <Input
                    value={tarifForm.code}
                    onChange={(e) => setTarifForm({...tarifForm, code: e.target.value.toUpperCase()})}
                    placeholder="Ex: LEAD_BTP_PREM"
                    className="font-mono uppercase"
                    data-testid="tarif-form-code"
                  />
                </div>
              </div>
            </section>

            {/* === Section 2 : Perimetre === */}
            <section className="space-y-3">
              <h3 className="text-xs font-bold uppercase tracking-wider text-sky-700 flex items-center gap-2 border-l-4 border-sky-500 pl-2">
                Périmètre d'application
              </h3>
              <div className="grid grid-cols-3 gap-4">
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold text-slate-700">Type de demande</Label>
                  <Select value={tarifForm.type_demande} onValueChange={(v) => setTarifForm({...tarifForm, type_demande: v})}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      {TARIF_TYPES.map(t => (
                        <SelectItem key={t.value} value={t.value}>{t.icon} {t.label}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold text-slate-700">Territoire</Label>
                  <Select value={tarifForm.territoire} onValueChange={(v) => setTarifForm({...tarifForm, territoire: v})}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Tous</SelectItem>
                      {TERRITOIRES.map(t => {
                        const isDisabled = (tarifForm.territoires_disabled || []).includes(t.value);
                        return (
                          <SelectItem
                            key={t.value}
                            value={t.value}
                            disabled={isDisabled}
                            className={isDisabled ? 'opacity-50 line-through' : ''}
                          >
                            {t.label}{isDisabled ? ' (désactivé)' : ''}
                          </SelectItem>
                        );
                      })}
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold text-slate-700">Type d'entreprise</Label>
                  <Select value={tarifForm.type_entreprise} onValueChange={(v) => setTarifForm({...tarifForm, type_entreprise: v})}>
                    <SelectTrigger>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="all">Tous</SelectItem>
                      {TYPES_ENTREPRISES.map(t => {
                        const isDisabled = (tarifForm.types_entreprise_disabled || []).includes(t.value);
                        return (
                          <SelectItem
                            key={t.value}
                            value={t.value}
                            disabled={isDisabled}
                            className={isDisabled ? 'opacity-50 line-through' : ''}
                          >
                            {t.label}{isDisabled ? ' (désactivé)' : ''}
                          </SelectItem>
                        );
                      })}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              {/* Désactivation par tarif : territoires + types d'entreprise grisés */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-slate-50 rounded-lg border border-slate-200">
                <div className="space-y-2">
                  <Label className="text-sm font-semibold text-slate-700">
                    Territoires désactivés pour ce tarif
                  </Label>
                  <p className="text-xs text-slate-500">Cochez les territoires à griser pour ce type de demande.</p>
                  <div className="flex flex-wrap gap-2 mt-1">
                    {TERRITOIRES.map((t) => {
                      const isDisabled = (tarifForm.territoires_disabled || []).includes(t.value);
                      return (
                        <label
                          key={t.value}
                          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs cursor-pointer transition-all ${
                            isDisabled
                              ? 'bg-slate-300 text-slate-700 border-slate-400 line-through'
                              : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'
                          }`}
                          data-testid={`disable-territoire-${t.value}`}
                        >
                          <input
                            type="checkbox"
                            className="w-3.5 h-3.5 accent-slate-600"
                            checked={isDisabled}
                            onChange={(e) => {
                              const set = new Set(tarifForm.territoires_disabled || []);
                              if (e.target.checked) set.add(t.value); else set.delete(t.value);
                              setTarifForm({ ...tarifForm, territoires_disabled: Array.from(set) });
                            }}
                          />
                          {t.label}
                        </label>
                      );
                    })}
                  </div>
                </div>

                <div className="space-y-2">
                  <Label className="text-sm font-semibold text-slate-700">
                    Types d'entreprise désactivés pour ce tarif
                  </Label>
                  <p className="text-xs text-slate-500">Cochez les types d'entreprise à griser pour ce type de demande.</p>
                  <div className="flex flex-wrap gap-2 mt-1">
                    {TYPES_ENTREPRISES.map((t) => {
                      const isDisabled = (tarifForm.types_entreprise_disabled || []).includes(t.value);
                      return (
                        <label
                          key={t.value}
                          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs cursor-pointer transition-all ${
                            isDisabled
                              ? 'bg-slate-300 text-slate-700 border-slate-400 line-through'
                              : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'
                          }`}
                          data-testid={`disable-type-entreprise-${t.value}`}
                        >
                          <input
                            type="checkbox"
                            className="w-3.5 h-3.5 accent-slate-600"
                            checked={isDisabled}
                            onChange={(e) => {
                              const set = new Set(tarifForm.types_entreprise_disabled || []);
                              if (e.target.checked) set.add(t.value); else set.delete(t.value);
                              setTarifForm({ ...tarifForm, types_entreprise_disabled: Array.from(set) });
                            }}
                          />
                          {t.label}
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
            </section>

            {/* === Section 3 : Tarification === */}
            <section className="space-y-3">
              <h3 className="text-xs font-bold uppercase tracking-wider text-emerald-700 flex items-center gap-2 border-l-4 border-emerald-500 pl-2">
                Tarification
              </h3>
              <div className="grid grid-cols-2 gap-4">
                <div className="p-4 bg-gradient-to-br from-emerald-50 to-emerald-100/40 rounded-lg border border-emerald-200 shadow-sm">
                  <Label className="text-emerald-800 font-semibold flex items-center gap-1.5">
                    <span className="text-lg">€</span> Prix en Euros
                  </Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={tarifForm.prix_base}
                    onChange={(e) => setTarifForm({...tarifForm, prix_base: parseFloat(e.target.value) || 0})}
                    className="mt-2 text-2xl font-bold text-emerald-900 border-emerald-300 focus-visible:ring-emerald-500"
                    data-testid="tarif-form-prix-euros"
                  />
                </div>
                <div className="p-4 bg-gradient-to-br from-purple-50 to-purple-100/40 rounded-lg border border-purple-200 shadow-sm">
                  <Label className="text-purple-800 font-semibold flex items-center gap-1.5">
                    <span className="text-lg">◆</span> Prix en Crédits
                  </Label>
                  <Input
                    type="number"
                    step="1"
                    value={tarifForm.prix_credits}
                    onChange={(e) => setTarifForm({...tarifForm, prix_credits: parseInt(e.target.value) || 0})}
                    className="mt-2 text-2xl font-bold text-purple-900 border-purple-300 focus-visible:ring-purple-500"
                    data-testid="tarif-form-prix-credits"
                  />
                </div>
              </div>
            </section>

            {/* === Section 4 : Coefficients & remises === */}
            <section className="space-y-3">
              <h3 className="text-xs font-bold uppercase tracking-wider text-amber-700 flex items-center gap-2 border-l-4 border-amber-500 pl-2">
                Coefficients &amp; Remises
              </h3>
              <div className="grid grid-cols-4 gap-3 p-3 bg-amber-50/40 rounded-lg border border-amber-200">
                <div className="space-y-1.5">
                  <Label className="text-xs font-medium text-slate-700">Coef. urgence</Label>
                  <Input
                    type="number"
                    step="0.1"
                    value={tarifForm.coefficient_urgence}
                    onChange={(e) => setTarifForm({...tarifForm, coefficient_urgence: parseFloat(e.target.value) || 1})}
                    className="text-center font-mono"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-medium text-slate-700">Coef. premium</Label>
                  <Input
                    type="number"
                    step="0.1"
                    value={tarifForm.coefficient_premium}
                    onChange={(e) => setTarifForm({...tarifForm, coefficient_premium: parseFloat(e.target.value) || 1})}
                    className="text-center font-mono"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-medium text-slate-700">Remise volume (%)</Label>
                  <Input
                    type="number"
                    step="1"
                    value={tarifForm.remise_volume}
                    onChange={(e) => setTarifForm({...tarifForm, remise_volume: parseInt(e.target.value) || 0})}
                    className="text-center font-mono"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-medium text-slate-700">Remise fidélité (%)</Label>
                  <Input
                    type="number"
                    step="1"
                    value={tarifForm.remise_fidelite}
                    onChange={(e) => setTarifForm({...tarifForm, remise_fidelite: parseInt(e.target.value) || 0})}
                    className="text-center font-mono"
                  />
                </div>
              </div>
            </section>

            {/* === Section 5 : Description & options === */}
            <section className="space-y-3">
              <h3 className="text-xs font-bold uppercase tracking-wider text-slate-700 flex items-center gap-2 border-l-4 border-slate-400 pl-2">
                Description &amp; Options
              </h3>
              <div className="space-y-2">
                <Label className="text-xs font-semibold text-slate-700">Description</Label>
                <Textarea
                  value={tarifForm.description}
                  onChange={(e) => setTarifForm({...tarifForm, description: e.target.value})}
                  placeholder="Description du tarif..."
                  rows={2}
                />
              </div>
              <div className="flex items-center gap-4 p-3 bg-slate-50 rounded-lg border border-slate-200">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={tarifForm.tva_applicable}
                    onChange={(e) => setTarifForm({...tarifForm, tva_applicable: e.target.checked})}
                    className="h-4 w-4 accent-emerald-600"
                  />
                  <span className="text-sm font-medium text-slate-700">TVA applicable</span>
                </label>
                <div className="ml-auto flex items-center gap-2">
                  <Label className="text-sm font-medium text-slate-700">Tarif actif</Label>
                  <Switch
                    checked={tarifForm.is_active}
                    onCheckedChange={(v) => setTarifForm({...tarifForm, is_active: v})}
                  />
                </div>
              </div>
            </section>

            {/* === Section 6 : Taxes personnalisées === */}
            <section className="space-y-3">
              <h3 className="text-xs font-bold uppercase tracking-wider text-indigo-700 flex items-center gap-2 border-l-4 border-indigo-500 pl-2">
                Taxes personnalisées
              </h3>
              <div className="rounded-lg border border-indigo-200 bg-indigo-50/40 p-4 space-y-2">
                <div className="flex items-center justify-between">
                  <p className="text-xs text-slate-600">
                    Le front affiche uniquement le TTC. Le détail (libellé + taux %/montant) apparaît exclusivement sur la facture ou le reçu.
                  </p>
                  <Button
                    type="button"
                    size="sm"
                    variant="outline"
                    onClick={() => setTarifForm({
                      ...tarifForm,
                      taxes_personnalisees: [
                        ...(tarifForm.taxes_personnalisees || []),
                        { libelle: '', type: 'pourcentage', valeur: 0 }
                      ]
                    })}
                    className="border-indigo-400 text-indigo-700 hover:bg-indigo-100 shrink-0 ml-2"
                    data-testid="tarif-add-tax-btn"
                  >
                    <Plus className="w-3.5 h-3.5 mr-1" /> Ajouter
                  </Button>
                </div>
                {(tarifForm.taxes_personnalisees || []).length === 0 ? (
                  <div className="text-xs text-slate-400 italic px-2 py-1">Aucune taxe personnalisée.</div>
                ) : (
                  <div className="space-y-2">
                    {(tarifForm.taxes_personnalisees || []).map((tax, idx) => (
                      <div key={idx} className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg p-2" data-testid={`tarif-tax-row-${idx}`}>
                        <Input
                          placeholder="Libellé (ex: TVA, Octroi de mer…)"
                          value={tax.libelle}
                          onChange={(e) => {
                            const next = [...tarifForm.taxes_personnalisees];
                            next[idx] = { ...next[idx], libelle: e.target.value };
                            setTarifForm({ ...tarifForm, taxes_personnalisees: next });
                          }}
                          className="flex-1"
                        />
                        <select
                          value={tax.type}
                          onChange={(e) => {
                            const next = [...tarifForm.taxes_personnalisees];
                            next[idx] = { ...next[idx], type: e.target.value };
                            setTarifForm({ ...tarifForm, taxes_personnalisees: next });
                          }}
                          className="border border-slate-300 rounded-md px-2 py-1 text-sm bg-white"
                        >
                          <option value="pourcentage">Pourcentage</option>
                          <option value="montant">Montant fixe</option>
                        </select>
                        <div className="relative w-28">
                          <Input
                            type="number"
                            step="0.01"
                            value={tax.valeur}
                            onChange={(e) => {
                              const next = [...tarifForm.taxes_personnalisees];
                              next[idx] = { ...next[idx], valeur: parseFloat(e.target.value) || 0 };
                              setTarifForm({ ...tarifForm, taxes_personnalisees: next });
                            }}
                            className="pr-7"
                          />
                          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-slate-500">
                            {tax.type === 'pourcentage' ? '%' : '€'}
                          </span>
                        </div>
                        <Button
                          type="button"
                          size="sm"
                          variant="ghost"
                          onClick={() => {
                            const next = tarifForm.taxes_personnalisees.filter((_, i) => i !== idx);
                            setTarifForm({ ...tarifForm, taxes_personnalisees: next });
                          }}
                          className="text-red-600 hover:bg-red-50 px-2"
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </section>
          </div>

          <DialogFooter className="border-t pt-3 mt-2 sticky bottom-0 bg-white">
            <Button variant="outline" onClick={() => { setTarifDialogOpen(false); resetTarifForm(); }}>
              Annuler
            </Button>
            <Button onClick={handleSaveTarif} className="bg-emerald-600 hover:bg-emerald-700" data-testid="tarif-form-save-btn">
              <Save className="h-4 w-4 mr-2" />
              {editingTarif ? 'Mettre à jour' : 'Créer'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default TarifDialog;
